// firebase
import db from "@/firebase/init";
// moment
import moment from "moment";
moment.locale("pt-br");
// rfdc
const clone = require("rfdc")();

export default async function generateWeeklyMealplan(userId) {

    // definitions
    const deviationTargetKcalMAX = 1.15;
    const deviationTargetKcalMIN = 0.85;

    // get user
    async function getUser(userId) {
        let result;
        try {
            const snapshot = await db
                .collection("users")
                .where("userId", "==", userId)
                .get();
            snapshot.forEach(doc => {
                result = {
                    id: doc.id,
                    data: doc.data()
                };
            });
        } catch (e) {
            console.log(e);
        }
        return result;
    }

    // get date to start generating mealplans
    async function getInitialDate(userId) {
        let maxDate = moment();
        try {
            const snapshot = await db
                .collection("mealplans")
                .where("userId", "==", userId)
                .get();
            snapshot.forEach(doc => {
                const data = doc.data();
                const day = moment(data.day, "DD/MM/YYYY").format();
                if (moment(day).isAfter(maxDate)) {
                    maxDate = day;
                }
            });
        } catch (e) {
            console.log(e);
        }
        return maxDate;
    }

    // weight meals based on user data
    function mealWeights(meals, kcal) {
        const mealWeights = {
            lunch: 4,
            dinner: 3,
            breakfast: 2,
            afternoonSnack: 1,
            morningSnack: 1,
            supper: 1
        };

        let weight = 0;

        if (meals.includes("lunch")) {
            weight += mealWeights.lunch;
        }
        if (meals.includes("dinner")) {
            weight += mealWeights.dinner;
        }
        if (meals.includes("breakfast")) {
            weight += mealWeights.breakfast;
        }
        if (meals.includes("afternoonSnack")) {
            weight += mealWeights.afternoonSnack;
        }
        if (meals.includes("morningSnack")) {
            weight += mealWeights.morningSnack;
        }
        if (meals.includes("supper")) {
            weight += mealWeights.supper;
        }

        let weightedMeals = {
            lunch: {
                target: null,
                max: null,
                min: null
            },
            dinner: {
                target: null,
                max: null,
                min: null
            },
            breakfast: {
                target: null,
                max: null,
                min: null
            },
            afternoonSnack: {
                target: null,
                max: null,
                min: null
            },
            morningSnack: {
                target: null,
                max: null,
                min: null
            },
            supper: {
                target: null,
                max: null,
                min: null
            }
        };

        for (let i = 0; i < meals.length; i++) {
            if (meals[i] === "lunch") {
                weightedMeals.lunch.target = Math.round(
                    (mealWeights.lunch / weight) * kcal
                );
                weightedMeals.lunch.max = Math.round(weightedMeals.lunch.target * deviationTargetKcalMAX);
                weightedMeals.lunch.min = Math.round(weightedMeals.lunch.target * deviationTargetKcalMIN);
            } else if (meals[i] === "dinner") {
                weightedMeals.dinner.target = Math.round(
                    (mealWeights.dinner / weight) * kcal
                );
                weightedMeals.dinner.max = Math.round(
                    weightedMeals.dinner.target * deviationTargetKcalMAX
                );
                weightedMeals.dinner.min = Math.round(
                    weightedMeals.dinner.target * deviationTargetKcalMIN
                );
            } else if (meals[i] === "breakfast") {
                weightedMeals.breakfast.target = Math.round(
                    (mealWeights.breakfast / weight) * kcal
                );
                weightedMeals.breakfast.max = Math.round(
                    weightedMeals.breakfast.target * deviationTargetKcalMAX
                );
                weightedMeals.breakfast.min = Math.round(
                    weightedMeals.breakfast.target * deviationTargetKcalMIN
                );
            } else if (meals[i] === "afternoonSnack") {
                weightedMeals.afternoonSnack.target = Math.round(
                    (mealWeights.afternoonSnack / weight) * kcal
                );
                weightedMeals.afternoonSnack.max = Math.round(
                    weightedMeals.afternoonSnack.target * deviationTargetKcalMAX
                );
                weightedMeals.afternoonSnack.min = Math.round(
                    weightedMeals.afternoonSnack.target * deviationTargetKcalMIN
                );
            } else if (meals[i] === "morningSnack") {
                weightedMeals.morningSnack.target = Math.round(
                    (mealWeights.morningSnack / weight) * kcal
                );
                weightedMeals.morningSnack.max = Math.round(
                    weightedMeals.morningSnack.target * deviationTargetKcalMAX
                );
                weightedMeals.morningSnack.min = Math.round(
                    weightedMeals.morningSnack.target * deviationTargetKcalMIN
                );
            } else if (meals[i] === "supper") {
                weightedMeals.supper.target = Math.round(
                    (mealWeights.supper / weight) * kcal
                );
                weightedMeals.supper.max = Math.round(
                    weightedMeals.supper.target * deviationTargetKcalMAX
                );
                weightedMeals.supper.min = Math.round(
                    weightedMeals.supper.target * deviationTargetKcalMIN
                );
            } else {
                //
            }
        }
        return weightedMeals;
    }

    // get options for each meal
    async function getOptions(meal, target) {
        let mealOptions = [];
        try {
            let snap;
            if (meal === "breakfast") {
                if (target) {
                    snap = await db
                        .collection("dishes")
                        .where("breakfast", "==", true)
                        .get();
                }
            } else if (meal === "morningSnack") {
                if (target) {
                    snap = await db
                        .collection("dishes")
                        .where("morningSnack", "==", true)
                        .get();
                }
            } else if (meal === "lunch") {
                if (target) {
                    snap = await db
                        .collection("dishes")
                        .where("lunch", "==", true)
                        .get();
                }
            } else if (meal === "afternoonSnack") {
                if (target) {
                    snap = await db
                        .collection("dishes")
                        .where("afternoonSnack", "==", true)
                        .get();
                }
            } else if (meal === "dinner") {
                if (target) {
                    snap = await db
                        .collection("dishes")
                        .where("dinner", "==", true)
                        .get();
                }
            } else if (meal === "supper") {
                if (target) {
                    snap = await db
                        .collection("dishes")
                        .where("supper", "==", true)
                        .get();
                }
            } else {
                //
            }
            if (snap) {
                snap.forEach(doc => {
                    const data = doc.data();
                    data.chosenProportion = 100;
                    const docObj = {
                        id: doc.id,
                        data: data
                    };
                    mealOptions.push(docObj);
                });
            }
            return mealOptions;
        } catch (e) {
            console.log(e);
        }
    }

    // generate mealplan
    async function generateMealplan(params) {
        const {
            target,
            meals,
            weightedMeals,
            start,
            numDays,
            allergies,
            restrictions,
            breakfastOptions,
            morningSnackOptions,
            lunchOptions,
            afternoonSnackOptions,
            dinnerOptions,
            supperOptions
        } = params;

        let result = [];
        try {
            for (let d = 0; d <= numDays; d++) {

                console.log('NEW DAY');

                const td = moment(start).add(d, "days");
                const dayOfWeek = moment(td).isoWeekday();

                let targetKcalDay = target.kcal;
                let targetFatDay = target.fat;
                let targetCarbsDay = target.carbs;
                let targetProteinDay = target.protein;

                let currentKcalDay = 0;
                let currentFatDay = 0;
                let currentCarbsDay = 0;
                let currentProteinDay = 0;

                let minKcal = 0;
                let targetKcal = 0;
                let maxKcal = 100000;

                let eliminationList = [];

                for (let m = 0; m < meals.length; m++) {

                    let lastMeal;
                    if (m === meals.length - 1) {
                        lastMeal = true;
                    } else {
                        lastMeal = false;
                    }

                    const meal = meals[m];
                    console.log('MEAL: ', meal);
                    let options = [];
                    if (meal === "breakfast") {
                        options = clone(breakfastOptions);
                        minKcal = weightedMeals.breakfast.min;
                        targetKcal = weightedMeals.breakfast.target;
                        maxKcal = weightedMeals.breakfast.max;
                    } else if (meal === "morningSnack") {
                        options = clone(morningSnackOptions);
                        minKcal = weightedMeals.morningSnack.min;
                        targetKcal = weightedMeals.morningSnack.target;
                        maxKcal = weightedMeals.morningSnack.max;
                    } else if (meal === "lunch") {
                        options = clone(lunchOptions);
                        minKcal = weightedMeals.lunch.min;
                        targetKcal = weightedMeals.lunch.target;
                        maxKcal = weightedMeals.lunch.max;
                    } else if (meal === "afternoonSnack") {
                        options = clone(afternoonSnackOptions);
                        minKcal = weightedMeals.afternoonSnack.min;
                        targetKcal = weightedMeals.afternoonSnack.target;
                        maxKcal = weightedMeals.afternoonSnack.max;
                    } else if (meal === "dinner") {
                        options = clone(dinnerOptions);
                        minKcal = weightedMeals.dinner.min;
                        targetKcal = weightedMeals.dinner.target;
                        maxKcal = weightedMeals.dinner.max;
                    } else if (meal === "supper") {
                        options = clone(supperOptions);
                        minKcal = weightedMeals.supper.min;
                        targetKcal = weightedMeals.supper.target;
                        maxKcal = weightedMeals.supper.max;
                    } else {
                        //
                    }

                    // eliminate wrong

                    for (let i = options.length - 1; i >= 0; i--) {
                        if (options[i].data.eliminate) {
                            if (options.length > 2) {
                                options.splice(i, 1);
                            }
                        }
                    }

                    // eliminate unfit for diet

                    if (target.diet) {
                        if (target.diet === 'lowCarb') {
                            for (let i = options.length - 1; i >= 0; i--) {
                                if (!options[i].data.lowCarb) {
                                    if (options.length > 2) {
                                        options.splice(i, 1);
                                    }
                                }
                            }
                        } else if (target.diet === 'highProtein') {
                            for (let i = options.length - 1; i >= 0; i--) {
                                if (!options[i].data.highProtein) {
                                    if (options.length > 2) {
                                        options.splice(i, 1);
                                    }
                                }
                            }
                        } else {
                            //
                        }
                    }

                    // eliminate duplicates for same day

                    console.log('options available before eliminating duplicates: ', options.length);

                    if (eliminationList.length > 0) {
                        for (let i = options.length - 1; i >= 0; i--) {
                            if (eliminationList.includes(options[i].id)) {
                                if (options.length > 2) {
                                    options.splice(i, 1);
                                }
                            }
                        }
                    }

                    console.log('options available after eliminating duplicates for same day: ', options.length);

                    // restrictions filter

                    if (options.length > 0) {
                        if (restrictions.length > 0) {
                            for (let i = options.length - 1; i >= 0; i--) {
                                if (options[i]) {
                                    if (restrictions.includes("vegan")) {
                                        if (!options[i].data.nutritionalInfo.vegan) {
                                            options.splice(i, 1);
                                        }
                                    }
                                }
                                if (options[i]) {
                                    if (restrictions.includes("vegetarian")) {
                                        if (!options[i].data.nutritionalInfo.vegetarian) {
                                            options.splice(i, 1);
                                        }
                                    } else if (restrictions.includes("meatFreeMonday") && dayOfWeek === 1) {
                                        if (!options[i].data.nutritionalInfo.vegetarian) {
                                            options.splice(i, 1);
                                        }
                                    } else {
                                        //
                                    }
                                }
                                if (options[i]) {
                                    if (restrictions.includes("lactoseFree")) {
                                        if (!options[i].data.nutritionalInfo.lactoseFree) {
                                            options.splice(i, 1);
                                        }
                                    }
                                }
                                if (options[i]) {
                                    if (restrictions.includes("glutenFree")) {
                                        if (!options[i].data.nutritionalInfo.glutenFree) {
                                            options.splice(i, 1);
                                        }
                                    }
                                }
                            }
                        }

                        console.log('options available after restrictions: ', options.length);

                        // allergies filter

                        if (allergies.length > 0) {
                            for (let i = options.length - 1; i >= 0; i--) {
                                if (options[i]) {
                                    if (allergies.includes("gluten")) {
                                        if (options[i].data.gluten) {
                                            options.splice(i, 1);
                                        }
                                    }
                                }
                                if (options[i]) {
                                    if (allergies.includes("crustaceans")) {
                                        if (options[i].data.crustaceans) {
                                            options.splice(i, 1);
                                        }
                                    }
                                }
                                if (options[i]) {
                                    if (allergies.includes("eggs")) {
                                        if (options[i].data.eggs) {
                                            options.splice(i, 1);
                                        }
                                    }
                                }
                                if (options[i]) {
                                    if (allergies.includes("fish")) {
                                        if (options[i].data.fish) {
                                            options.splice(i, 1);
                                        }
                                    }
                                }
                                if (options[i]) {
                                    if (allergies.includes("peanuts")) {
                                        if (options[i].data.peanuts) {
                                            options.splice(i, 1);
                                        }
                                    }
                                }
                                if (options[i]) {
                                    if (allergies.includes("soya")) {
                                        if (options[i].data.soya) {
                                            options.splice(i, 1);
                                        }
                                    }
                                }
                                if (options[i]) {
                                    if (allergies.includes("milk")) {
                                        if (options[i].data.milk) {
                                            options.splice(i, 1);
                                        }
                                    }
                                }
                                if (options[i]) {
                                    if (allergies.includes("nuts")) {
                                        if (options[i].data.nuts) {
                                            options.splice(i, 1);
                                        }
                                    }
                                }
                                if (options[i]) {
                                    if (allergies.includes("celery")) {
                                        if (options[i].data.celery) {
                                            options.splice(i, 1);
                                        }
                                    }
                                }
                                if (options[i]) {
                                    if (allergies.includes("mustard")) {
                                        if (options[i].data.mustard) {
                                            options.splice(i, 1);
                                        }
                                    }
                                }
                                if (options[i]) {
                                    if (allergies.includes("sesame")) {
                                        if (options[i].data.sesame) {
                                            options.splice(i, 1);
                                        }
                                    }
                                }
                                if (options[i]) {
                                    if (allergies.includes("sulphites")) {
                                        if (options[i].data.sulphites) {
                                            options.splice(i, 1);
                                        }
                                    }
                                }
                                if (options[i]) {
                                    if (allergies.includes("lupin")) {
                                        if (options[i].data.lupin) {
                                            options.splice(i, 1);
                                        }
                                    }
                                }
                                if (options[i]) {
                                    if (allergies.includes("molluscs")) {
                                        if (options[i].data.molluscs) {
                                            options.splice(i, 1);
                                        }
                                    }
                                }
                            }
                        }

                        console.log('options available after allergies: ', options.length);

                        // kcal filter

                        const optionsInitial = clone(options);

                        if (lastMeal) {
                            let targetKcalLastMeal;
                            const kcalRemaining = targetKcalDay - currentKcalDay;
                            if (kcalRemaining < 200) {
                                targetKcalLastMeal = 200;
                            } else {
                                targetKcalLastMeal = kcalRemaining;
                            }
                            const maxKcalLastMeal = targetKcalLastMeal * deviationTargetKcalMAX;
                            const minKcalLastMeal = targetKcalLastMeal * deviationTargetKcalMIN;
                            for (let i = options.length - 1; i >= 0; i--) {
                                if (options[i]) {
                                    let propList = [100];
                                    if (options[i].data.foods125) {
                                        propList.push(125);
                                    }
                                    if (options[i].data.foods150) {
                                        propList.push(150);
                                    }
                                    if (options[i].data.foods175) {
                                        propList.push(175);
                                    }
                                    if (options[i].data.foods200) {
                                        propList.push(200);
                                    }
                                    if (options[i].data.foods225) {
                                        propList.push(225);
                                    }
                                    if (options[i].data.foods250) {
                                        propList.push(250);
                                    }
                                    if (options[i].data.foods275) {
                                        propList.push(275);
                                    }
                                    if (options[i].data.foods300) {
                                        propList.push(300);
                                    }
                                    if (options[i].data.foods325) {
                                        propList.push(325);
                                    }
                                    if (options[i].data.foods350) {
                                        propList.push(350);
                                    }
                                    if (options[i].data.foods375) {
                                        propList.push(375);
                                    }
                                    if (options[i].data.foods400) {
                                        propList.push(400);
                                    }

                                    let splice = true;
                                    let chosenProportion;

                                    for (let p = 0; p < propList.length; p++) {
                                        const optionKcal = options[i].data.nutritionalInfo.calories * propList[p] / 100;
                                        if (optionKcal <= maxKcalLastMeal && optionKcal >= minKcalLastMeal) {
                                            splice = false;
                                            chosenProportion = propList[p];
                                        }
                                    }

                                    if (splice) {
                                        if (options.length > 2) {
                                            options.splice(i, 1);
                                        }
                                    } else {
                                        options[i].data.chosenProportion = chosenProportion;
                                    }
                                }
                            }
                        } else {
                            for (let i = options.length - 1; i >= 0; i--) {
                                if (options[i]) {
                                    let propList = [100];
                                    if (options[i].data.foods125) {
                                        propList.push(125);
                                    }
                                    if (options[i].data.foods150) {
                                        propList.push(150);
                                    }
                                    if (options[i].data.foods175) {
                                        propList.push(175);
                                    }
                                    if (options[i].data.foods200) {
                                        propList.push(200);
                                    }
                                    if (options[i].data.foods225) {
                                        propList.push(225);
                                    }
                                    if (options[i].data.foods250) {
                                        propList.push(250);
                                    }
                                    if (options[i].data.foods275) {
                                        propList.push(275);
                                    }
                                    if (options[i].data.foods300) {
                                        propList.push(300);
                                    }
                                    if (options[i].data.foods325) {
                                        propList.push(325);
                                    }
                                    if (options[i].data.foods350) {
                                        propList.push(350);
                                    }
                                    if (options[i].data.foods375) {
                                        propList.push(375);
                                    }
                                    if (options[i].data.foods400) {
                                        propList.push(400);
                                    }

                                    let splice = true;
                                    let chosenProportion;

                                    for (let p = 0; p < propList.length; p++) {
                                        const optionKcal = options[i].data.nutritionalInfo.calories * propList[p] / 100;
                                        if (optionKcal <= maxKcal && optionKcal >= minKcal) {
                                            splice = false;
                                            chosenProportion = propList[p];
                                        }
                                    }

                                    if (splice) {
                                        if (options.length > 2) {
                                            options.splice(i, 1);
                                        }
                                    } else {
                                        options[i].data.chosenProportion = chosenProportion;
                                    }
                                }
                            }
                        }

                        console.log('options length after kcal filter: ', options.length);

                        // LPC filter

                        const propMeal = targetKcal / targetKcalDay;

                        const fatExpectedMeal = targetFatDay * propMeal;
                        const carbsExpectedMeal = targetCarbsDay * propMeal;
                        const proteinExpectedMeal = targetProteinDay * propMeal;

                        const maxFatMeal = fatExpectedMeal * 1.5;
                        const maxCarbsMeal = carbsExpectedMeal * 1.5;
                        let minProteinMeal;

                        if (meal === "lunch" || meal === "dinner") {
                            minProteinMeal = proteinExpectedMeal * 0.5;
                        } else if (meal === "breakfast") {
                            minProteinMeal = proteinExpectedMeal * 0.1;
                        } else {
                            minProteinMeal = 0;
                        }

                        for (let i = options.length - 1; i >= 0; i--) {
                            if (options[i] && options.length > 2) {
                                const fat = options[i].data.nutritionalInfo.fat;
                                const carbs = options[i].data.nutritionalInfo.carbs;
                                const protein = options[i].data.nutritionalInfo.protein;
                                if (options.length > 2) {
                                    if (fat > maxFatMeal) {
                                        if (options.length > 2) {
                                            options.splice(i, 1);
                                        }
                                    }
                                    if (carbs > maxCarbsMeal) {
                                        if (options.length > 2) {
                                            options.splice(i, 1);
                                        }
                                    }
                                    if (protein < minProteinMeal) {
                                        if (options.length > 2) {
                                            options.splice(i, 1);
                                        }
                                    }
                                }
                            }
                        }

                        // eliminate duplicates for previous day

                        if (d > 0) {
                            const yesterday = moment(start)
                                .add(d - 1, "days")
                                .format("DD/MM/YYYY");
                            console.log('yesterday: ', yesterday);
                            const currentResults = clone(result);
                            for (let i = options.length - 1; i >= 0; i--) {
                                for (let j = 0; j < currentResults.length; j++) {
                                    if (currentResults[j].day === yesterday) {
                                        if (currentResults[j].chosenDish.id === options[i].id) {
                                            console.log('duplicate found!');
                                            options[i].data.duplicate = true;
                                        }
                                    }
                                }
                            }
                        }

                        console.log('options available after eliminating duplicates for previous day: ', options.length);

                        // generate alternatives

                        console.log('options length after LPC filter: ', options.length);

                        let weightedList = [];

                        for (let i = 0; i < options.length; i++) {
                            if (options[i]) {
                                if (options[i].data.priorityLevel) {
                                    if (options[i].data.priorityLevel === 1) {
                                        weightedList.push(options[i]);
                                    } else if (options[i].data.priorityLevel === 2) {
                                        weightedList.push(options[i]);
                                        weightedList.push(options[i]);
                                    } else if (options[i].data.priorityLevel === 3) {
                                        weightedList.push(options[i]);
                                        weightedList.push(options[i]);
                                        weightedList.push(options[i]);
                                    } else if (options[i].data.priorityLevel === 4) {
                                        weightedList.push(options[i]);
                                        weightedList.push(options[i]);
                                        weightedList.push(options[i]);
                                        weightedList.push(options[i]);
                                    } else {
                                        //
                                    }
                                } else {
                                    weightedList.push(options[i]);
                                }
                            }
                        }

                        let chosenMealIndex;
                        let counter = 0;
                        do {
                            counter += 1;
                            chosenMealIndex = Math.floor(Math.random() * weightedList.length);
                        }
                        while (counter < 10 && (!chosenMealIndex || weightedList[chosenMealIndex].data.duplicate))
                        eliminationList.push(weightedList[chosenMealIndex].id);

                        let chosenMeal = weightedList[chosenMealIndex] || {
                            id: null,
                            data: {
                                chosenProportion: null
                            }
                        };

                        let optionsAlt1 = clone(weightedList);
                        for (let i = optionsAlt1.length - 1; i >= 0; i--) {
                            if (optionsAlt1[i].id === chosenMeal.id) {
                                optionsAlt1.splice(i, 1);
                            }
                        }
                        const alt1Index = Math.floor(Math.random() * optionsAlt1.length);
                        let alt1 = optionsAlt1[alt1Index] || {
                            id: null,
                            data: {
                                chosenProportion: null
                            }
                        };

                        let optionsAlt2 = clone(optionsAlt1);
                        for (let i = optionsAlt2.length - 1; i >= 0; i--) {
                            if (optionsAlt2[i].id === alt1.id) {
                                optionsAlt2.splice(i, 1);
                            }
                        }
                        const alt2Index = Math.floor(Math.random() * optionsAlt2.length);
                        let alt2 = optionsAlt2[alt2Index] || {
                            id: null,
                            data: {
                                chosenProportion: null
                            }
                        };

                        let optionsAlt3 = clone(optionsAlt2);
                        for (let i = optionsAlt3.length - 1; i >= 0; i--) {
                            if (optionsAlt3[i].id === alt2.id) {
                                optionsAlt3.splice(i, 1);
                            }
                        }
                        const alt3Index = Math.floor(Math.random() * optionsAlt3.length);
                        let alt3 = optionsAlt3[alt3Index] || {
                            id: null,
                            data: {
                                chosenProportion: null
                            }
                        };

                        if (!chosenMeal.id) {
                            console.log('none found! taking random');
                            const chosenMealIndex = Math.floor(Math.random() * options.length);
                            chosenMeal = optionsInitial[chosenMealIndex] || {
                                id: null,
                                data: {
                                    chosenProportion: null
                                }
                            };
                        }

                        // update daily nutritional values

                        if (chosenMeal) {
                            currentKcalDay += chosenMeal.data.nutritionalInfo.calories * chosenMeal.data.chosenProportion / 100;
                            currentFatDay += chosenMeal.data.nutritionalInfo.fat * chosenMeal.data.chosenProportion / 100;
                            currentCarbsDay += chosenMeal.data.nutritionalInfo.carbs * chosenMeal.data.chosenProportion / 100;
                            currentProteinDay += chosenMeal.data.nutritionalInfo.protein * chosenMeal.data.chosenProportion / 100;
                            /*
                            fatDay +=
                                (chosenMeal.data.nutritionalInfo.fat *
                                    chosenMeal.data.chosenProportion) /
                                100;
                            proteinDay +=
                                (chosenMeal.data.nutritionalInfo.protein *
                                    chosenMeal.data.chosenProportion) /
                                100;
                            carbsDay +=
                                (chosenMeal.data.nutritionalInfo.carbs *
                                    chosenMeal.data.chosenProportion) /
                                100;
                            */
                        }

                        const day = moment(start)
                            .add(d, "days")
                            .format("DD/MM/YYYY");
                        const chosenMealObj = {
                            day: day,
                            meal: meal,
                            chosenDish: {
                                id: chosenMeal.id,
                                proportion: chosenMeal.data.chosenProportion
                            },
                            alternatives: [{
                                    id: alt1.id,
                                    proportion: alt1.data.chosenProportion
                                },
                                {
                                    id: alt2.id,
                                    proportion: alt2.data.chosenProportion
                                },
                                {
                                    id: alt3.id,
                                    proportion: alt3.data.chosenProportion
                                }
                            ]
                        };
                        result.push(chosenMealObj);
                    }
                }
            }
            return result;
        } catch (e) {
            console.log(e);
        }
    }

    // start running

    const start = await getInitialDate(userId);

    let numDays = 0;
    if (moment(start).day() === 0) {
        // sunday to next saturday
        numDays = 6;
    } else if (moment(start).day() === 1) {
        // monday to next saturday
        numDays = 5;
    } else if (moment(start).day() === 2) {
        // tuesday to next saturday
        numDays = 4;
    } else if (moment(start).day() === 3) {
        // wednesday to next saturday
        numDays = 3;
    } else if (moment(start).day() === 4) {
        // thursday to next saturday
        numDays = 2;
    } else if (moment(start).day() === 5) {
        // friday to next saturday
        numDays = 1;
    } else if (moment(start).day() === 6) {
        // saturday to next saturday
        numDays = 7;
    } else {
        //
    }

    const user = await getUser(userId);

    if (user) {
        const data = user.data;
        if (data.target) {
            try {
                const target = {
                    diet: data.target.diet,
                    kcal: data.target.kcal,
                    fat: data.target.fat,
                    saturatedFat: data.target.saturatedFat,
                    transFat: data.target.transFat,
                    cholesterol: data.target.cholesterol,
                    sodium: data.target.sodium,
                    carbs: data.target.carbs,
                    fibers: data.target.fibers,
                    sugar: data.target.sugar,
                    protein: data.target.protein,
                    vitA: data.target.vitA,
                    vitC: data.target.vitC,
                    calcium: data.target.calcium,
                    iron: data.target.iron
                };

                const allergies = data.allergies || [];
                const restrictions = data.restrictions || [];

                let preferences = [];
                if (data.preferences) {
                    for (let i = 0; i < data.preferences.length; i++) {
                        preferences.push(data.preferences[i].id);
                    }
                }

                const meals = data.meals;
                const weightedMeals = mealWeights(meals, target.kcal);

                // generate options and filter kcal

                const breakfastOptions = await getOptions(
                    "breakfast",
                    weightedMeals.breakfast.target
                );

                const morningSnackOptions = await getOptions(
                    "morningSnack",
                    weightedMeals.morningSnack.target
                );

                const lunchOptions = await getOptions(
                    "lunch",
                    weightedMeals.lunch.target
                );

                const afternoonSnackOptions = await getOptions(
                    "afternoonSnack",
                    weightedMeals.afternoonSnack.target
                );

                const dinnerOptions = await getOptions(
                    "dinner",
                    weightedMeals.dinner.target
                );

                const supperOptions = await getOptions(
                    "supper",
                    weightedMeals.supper.target
                );

                const params = {
                    target: target,
                    meals: meals,
                    weightedMeals: weightedMeals,
                    start: start,
                    numDays: numDays,
                    allergies: allergies,
                    restrictions: restrictions,
                    breakfastOptions: clone(breakfastOptions),
                    morningSnackOptions: clone(morningSnackOptions),
                    lunchOptions: clone(lunchOptions),
                    afternoonSnackOptions: clone(afternoonSnackOptions),
                    dinnerOptions: clone(dinnerOptions),
                    supperOptions: clone(supperOptions)
                };

                const result = await generateMealplan(params);

                if (result) {
                    if (result.length > 0) {
                        for (let r = 0; r < result.length; r++) {
                            db.collection("mealplans")
                                .doc()
                                .set({
                                    userId: userId,
                                    day: result[r].day,
                                    meal: result[r].meal,
                                    chosenDish: result[r].chosenDish,
                                    alternatives: result[r].alternatives
                                });
                        }
                    }
                } else {
                    return;
                }
            } catch (e) {
                console.log(e);
                return;
            }
        }
    }
}